<template>
  <ul>
    <li
      v-for="range in rangeList.slice(0,maxLines)"
      :key="range.from + '-' + range.to"
    >
      <strong v-if="range.description">{{ range.description }}<br></strong>
      {{ getFormattedRange(range) }}
    </li>
    <li v-if="rangeList.length > maxLines">
      ...
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'RangeListCell',

    props: {
      rangeList: Array,
      maxLines: {
        type: Number,
        default: 5,
      },
    },

    methods: {
      getFormattedRange (range) {
        let result = range.from
        if (range.to) {
          result += '-' + range.to
        }
        result += ' ' + range.type
        return result
      },
    },
  }
</script>
